module.exports = __webpack_public_path__ + "media/images/bath-towels-0985d1ab.png";